import React from "react";

const Section1 = ({url}) => {
  return (
    <>
    <section className="home-section-1 d-flex align-items-center text-center"
    
        style={{
        // backgroundImage: `url("https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe")`,
        backgroundImage: `url("${url}images/omnix/banner.jpeg")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    }}
    >
      <div className="container">

        <h1 className="hero-title" data-aos="fade-up">
          Think Better <br />
          <h2 className="gradient-text">Decide Smarter</h2>
        </h1>

        <p className="hero-subtitle mt-3" data-aos="fade-up" data-aos-delay="200">
          Omnix brings multi agents AI platform to debate your hardest decisions, turning weeks of conflicting meetings into one confident answer in minutes
        </p>

        <button
          className="btn btn-gradient mt-4"
          data-aos="zoom-in"
          data-aos-delay="400"
        >
          See Omnix in Action
        </button>

        <div className="hero-images" data-aos="fade-up" data-aos-delay="600">
          <img src={`${url}images/omnix/banner-inner.png`} alt="" />
        </div>

      </div>
      {/* <div style={{ width: "100%" }}>
        <img src={`${url}images/omnix/banner-inner.png`} alt="" />
      </div> */}
    </section>
    {/* <section className="home-section-1-sub d-flex align-items-center text-center"
    
        style={{
        // backgroundImage: `url("https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe")`,
        backgroundImage: `url("${url}images/omnix/banner-small.jpeg")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height:"auto"
    }}
    >

    </section> */}
    </>
  );
};

export default Section1;